var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.lodash.has(_vm.regionData, "sectionsToHide.languageSelector")
    ? _c(
        "div",
        {
          staticClass: "dropdown language-dropdown",
          class: {
            "language-dropdown--mobile": _vm.screen === "mobile",
            "language-dropdown--desktop": _vm.screen === "desktop",
            "mr-4": !_vm.noMargin
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn px-0 language-dropdown-button",
              attrs: {
                id: "languageDropdown",
                "data-toggle": "dropdown",
                "aria-haspopup": "true"
              }
            },
            [
              _vm._v("\n        " + _vm._s(_vm.localeName) + "\n        "),
              _c("icon-component", {
                attrs: { height: "1em", icon: _vm.fa_chevron_down() }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dropdown-menu",
              class: { "dropdown-menu-right": _vm.screen === "mobile" },
              attrs: { "aria-labelledby": "languageDropdown" }
            },
            [
              _vm._l(_vm.settings.languages, function(language) {
                return [
                  language.locale !== _vm.locale
                    ? _c(
                        "div",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function($event) {
                              return _vm.changeLanguage(language)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(language.localName) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-234b8eea", { render: render, staticRenderFns: staticRenderFns })
  }
}